import { CategoryItem } from "@/mocks/categories";

interface CategoryCardProps {
  category: CategoryItem;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <a
      href={category.url}
      target="_blank"
      rel="noopener nofollow"
      className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[3/2] overflow-hidden bg-background-200/70">
        <img
          src={category.imageUrl}
          alt={category.name}
          title={`CSSBuy Spreadsheet ${category.name}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 flex items-center justify-center text-foreground-600 group-hover:text-primary-500 transition-colors duration-300">
            <i className={`${category.icon} text-xl`}></i>
          </span>
          <h3 className="text-base font-semibold text-foreground-950 whitespace-nowrap">
            {category.name}
          </h3>
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed">
          {category.description}
        </p>
        <div className="mt-3 flex items-center gap-1 text-sm text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="whitespace-nowrap">Explorar</span>
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </a>
  );
}